(function () {
  'use strict';

  var cartPage = document.getElementById('cartPage');
  if (!cartPage) return;

  var config = window.cartPageConfig || {};
  var moneyFormat = config.moneyFormat || window.themeMoneyFormat || '${{amount}}';
  var itemsList = document.getElementById('cartPageItems');
  var layout = document.getElementById('cartPageLayout');
  var emptyState = document.getElementById('cartPageEmpty');
  var subtotalEl = document.getElementById('cartPageSubtotal');
  var countEl = document.getElementById('cartPageCount');
  var summaryLines = document.getElementById('cartPageSummaryLines');
  var cartCountHeader = document.getElementById('cartCount');

  function formatMoney(cents) {
    if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
      return Shopify.formatMoney(cents, moneyFormat);
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function updateHeaderCount(count) {
    if (cartCountHeader) {
      cartCountHeader.textContent = count;
      cartCountHeader.hidden = count < 1;
    }
  }

  function updatePageState(cart) {
    var pricing = window.MSCartPricing;
    var visibleItems = (cart.items || []).filter(function (item) {
      return !pricing || !pricing.isCheckoutAdjustmentLine(item);
    });
    var count = pricing ? pricing.getVisibleItemCount(cart) : visibleItems.length;

    updateHeaderCount(count);

    if (countEl) {
      if (count > 0) {
        countEl.hidden = false;
        countEl.textContent = count + (count === 1 ? ' package ready for checkout' : ' packages ready for checkout');
      } else {
        countEl.hidden = true;
      }
    }

    if (subtotalEl) {
      if (!count) {
        subtotalEl.textContent = formatMoney(0);
      } else {
        subtotalEl.innerHTML = pricing
          ? pricing.formatSubtotalHtml(cart, formatMoney)
          : formatMoney(cart.total_price);
      }
    }

    if (summaryLines) {
      summaryLines.innerHTML = visibleItems.map(function (item) {
        var title = escapeHtml(item.product_title);
        var qty = item.quantity > 1 ? ' × ' + item.quantity : '';
        var priceHtml = pricing
          ? pricing.formatItemPriceHtml(item, formatMoney)
          : formatMoney(item.final_line_price);
        return (
          '<div class="cart-page__summary-line">' +
            '<span>' + title + qty + '</span>' +
            '<strong>' + priceHtml + '</strong>' +
          '</div>'
        );
      }).join('');
    }

    if (layout) layout.hidden = count === 0;
    if (emptyState) emptyState.hidden = count > 0;
  }

  function setItemBusy(itemEl, message, busy) {
    var overlay = itemEl.querySelector('.cart-item__overlay');
    var text = itemEl.querySelector('.cart-item__overlay-text');
    if (!overlay) return;
    if (text && message) text.textContent = message;
    overlay.hidden = !busy;
    itemEl.classList.toggle('cart-item--busy', busy);
  }

  function changeLine(key, line, quantity) {
    var payload = key ? { id: key, quantity: quantity } : { line: line, quantity: quantity };
    return fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function (res) {
      if (!res.ok) throw new Error('Cart update failed');
      return res.json();
    }).then(function (cart) {
      if (window.MSCartPricing) {
        return window.MSCartPricing.syncBundleAdjustments(cart);
      }
      return cart;
    });
  }

  function removeItemAnimated(itemEl, line, itemKey) {
    setItemBusy(itemEl, 'Removing item…', true);
    itemEl.classList.add('cart-item--removing');

    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        var item = cart.items[line - 1];
        var linked = item && window.MSCartPricing
          ? window.MSCartPricing.findLinkedAdjustmentItem(cart, item)
          : null;
        return changeLine(itemKey || (item && item.key) || '', line, 0).then(function (updatedCart) {
          if (!linked) return updatedCart;
          return changeLine(linked.key, cart.items.indexOf(linked) + 1, 0);
        });
      })
      .then(function (cart) {
        setItemBusy(itemEl, 'Done', true);
        itemEl.classList.add('cart-item--removed');

        return new Promise(function (resolve) {
          setTimeout(function () {
            itemEl.remove();
            updatePageState(cart);
            reindexLines();
            document.dispatchEvent(new CustomEvent('theme:cart-updated', { detail: { cart: cart } }));
            resolve(cart);
          }, 420);
        });
      })
      .catch(function () {
        setItemBusy(itemEl, 'Could not remove — try again', true);
        itemEl.classList.remove('cart-item--removing');
        setTimeout(function () {
          setItemBusy(itemEl, '', false);
        }, 1800);
      });
  }

  function updateQtyAnimated(itemEl, line, quantity, itemKey) {
    if (quantity < 0) return;
    setItemBusy(itemEl, 'Updating…', true);

    return changeLine(itemKey || itemEl.dataset.key || '', line, quantity)
      .then(function (cart) {
        setItemBusy(itemEl, '', false);
        var updated = itemKey
          ? cart.items.find(function (entry) { return entry.key === itemKey; })
          : cart.items[line - 1];
        if (!updated) {
          window.location.reload();
          return cart;
        }
        var qtyVal = itemEl.querySelector('.cart-item__qty-value');
        var priceEl = itemEl.querySelector('.cart-item__price');
        var qty = updated.quantity;
        if (qtyVal) qtyVal.textContent = qty;
        if (priceEl) {
          priceEl.innerHTML = window.MSCartPricing
            ? window.MSCartPricing.formatItemPriceHtml(updated, formatMoney)
            : formatMoney(updated.final_line_price);
        }
        itemEl.querySelectorAll('.cart-item__qty-btn').forEach(function (btn) {
          btn.dataset.cartQty = String(line);
          if (btn.textContent.trim() === '−') {
            btn.dataset.qty = String(qty - 1);
            btn.disabled = qty <= 1;
          } else {
            btn.dataset.qty = String(qty + 1);
            btn.disabled = false;
          }
        });
        updatePageState(cart);
        document.dispatchEvent(new CustomEvent('theme:cart-updated', { detail: { cart: cart } }));
        return cart;
      })
      .catch(function () {
        setItemBusy(itemEl, 'Update failed', true);
        setTimeout(function () { setItemBusy(itemEl, '', false); }, 1500);
      });
  }

  function reindexLines() {
    if (!itemsList) return;
    itemsList.querySelectorAll('.cart-item').forEach(function (item, index) {
      var line = index + 1;
      item.dataset.line = String(line);
      item.querySelectorAll('[data-cart-qty]').forEach(function (btn) {
        btn.dataset.cartQty = String(line);
      });
      var removeBtn = item.querySelector('[data-cart-remove]');
      if (removeBtn) removeBtn.dataset.cartRemove = String(line);
    });
  }

  function toggleEdit(itemEl, btn) {
    var details = itemEl.querySelector('.cart-item__details');
    if (!details) return;
    var open = details.hidden;
    details.hidden = !open;
    itemEl.classList.toggle('cart-item--open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.querySelector('span').textContent = open ? 'Hide' : 'Edit';
  }

  function fixSummaryTotalLines(cart) {
    if (!itemsList) return;
    cart.items.forEach(function (item, index) {
      var offerTotal = item.properties && item.properties.Total;
      if (!offerTotal) return;
      var itemEl = itemsList.querySelector('.cart-item[data-line="' + (index + 1) + '"]');
      if (!itemEl) return;
      var pre = itemEl.querySelector('.cart-item__summary-table');
      if (!pre) return;
      var lines = pre.textContent.split('\n');
      var i;
      for (i = lines.length - 1; i >= 0; i--) {
        if (lines[i].indexOf(':') === -1) continue;
        var normalized = lines[i].replace(/[^\x20-\x7E]/g, '').toUpperCase();
        if (normalized.indexOf('TOTAL') !== -1) {
          lines[i] = lines[i].split(':')[0] + ':             ' + offerTotal;
          break;
        }
      }
      pre.textContent = lines.join('\n');
    });
  }

  function refreshCartItemPrices(cart) {
    if (!itemsList || !window.MSCartPricing) return;
    cart.items.forEach(function (item, index) {
      var itemEl = itemsList.querySelector('.cart-item[data-line="' + (index + 1) + '"]');
      if (!itemEl) return;
      var priceEl = itemEl.querySelector('.cart-item__price');
      if (priceEl) {
        priceEl.innerHTML = window.MSCartPricing.formatItemPriceHtml(item, formatMoney);
      }
    });
  }

  function initCartPagePricing() {
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updatePageState(cart);
        refreshCartItemPrices(cart);
        fixSummaryTotalLines(cart);
        document.dispatchEvent(new CustomEvent('theme:cart-updated', { detail: { cart: cart } }));
        return cart;
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartPagePricing);
  } else {
    initCartPagePricing();
  }

  cartPage.addEventListener('click', function (e) {
    var editBtn = e.target.closest('[data-cart-edit]');
    if (editBtn) {
      e.preventDefault();
      toggleEdit(editBtn.closest('.cart-item'), editBtn);
      return;
    }

    var qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn && !qtyBtn.disabled) {
      e.preventDefault();
      var itemEl = qtyBtn.closest('.cart-item');
      var line = parseInt(qtyBtn.dataset.cartQty, 10);
      var qty = parseInt(qtyBtn.dataset.qty, 10);
      if (qty < 1) return;
      updateQtyAnimated(itemEl, line, qty, qtyBtn.dataset.cartKey || itemEl.dataset.key || '');
      return;
    }

    var removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      var removeItem = removeBtn.closest('.cart-item');
      removeItemAnimated(
        removeItem,
        parseInt(removeBtn.dataset.cartRemove, 10),
        removeBtn.dataset.cartKey || removeItem.dataset.key || ''
      );
    }
  });
})();
